import { ChoicesOrderStatus } from '@/types';

export const CANCELLABLE_ORDER_STATUSES = [
  ChoicesOrderStatus.pendingProvision,
  ChoicesOrderStatus.provisioning,
  ChoicesOrderStatus.failedProvision,
  ChoicesOrderStatus.completed,
];
